import { REDUCER_NAMESPACE } from './name';
export const GET_EXTENSIONS_LIST = `${REDUCER_NAMESPACE}/GET_EXTENSIONS_LIST`;
export const GET_EXTENSIONS_BY_ID = `${REDUCER_NAMESPACE}/GET_EXTENSIONS_BY_ID`;
export const CLEAR_EXTENSION = `${REDUCER_NAMESPACE}/CLEAR_EXTENSION`;
export const DOWNLOAD_STATISTICS = `${REDUCER_NAMESPACE}/DOWNLOAD_STATISTICS`;
export const GET_STATISTICS = `${REDUCER_NAMESPACE}/GET_STATISTICS`;
export const CLEAR_STATISTICS = `${REDUCER_NAMESPACE}/CLEAR_STATISTICS`;
export const SET_INSTITUTIONS_LIST = `${REDUCER_NAMESPACE}/SET_INSTITUTIONS_LIST`;
